import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',

      '& *.apexcharts-legend-series': {
        backgroundColor: 'transparent',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        transition: theme.transitions.create('background-color', {
          duration: theme.transitions.duration.standard,
          easing: theme.transitions.easing.easeInOut,
        }),
        cursor: 'zoom-in !important',

        '&:hover': {
          backgroundColor: theme.palette.grey[100],
        },
      },

      '& *.apexcharts-legend-marker[rel="1"]': {
        height: '2px !important',
      },
    },
    segmentsContainer: {
      display: 'flex',
      alignItems: 'center',

      '& > * + *': {
        marginLeft: theme.spacing(2),
      },
    },
    segmentButton: {
      minWidth: 'fit-content',
    },
    selectedSegment: {
      fontWeight: 'bold',
    },
    selectSegmentContainer: {
      minWidth: 150,
      overflow: 'hidden',
      display: 'flex',
      justifyContent: 'center',
    },
    skeleton: {
      transform: 'none',
    },
    chartSkeleton: {
      marginTop: theme.spacing(1.5),
    },
  }),
);
